import React from "react";
import AutoGraphOutlinedIcon from "@mui/icons-material/AutoGraphOutlined";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./NoStatsData.styles";

export const NoStatsData = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <AutoGraphOutlinedIcon className={classes.icon} />
            <Typography variant="h1" className={classes.title}>
                {t("HMI.stats-not-enough-data.title")}
            </Typography>
            <Typography variant="subtitle1" className={classes.subtitle}>
                {t("HMI.stats-not-enough-data.subtitle")}
            </Typography>
        </Box>
    );
};
